import { Box, Typography } from '@coolblue-development/freddy';
import { ReactNode } from 'react';

interface SettingsSectionProps {
  title: string;
  description: string;
  children: ReactNode;
}

const SettingsSection = ({ title, description, children }: SettingsSectionProps): JSX.Element => (
  <Box
    component="section"
    sx={{
      border: '1px solid #e0e0e0',
      borderRadius: '8px',
      backgroundColor: '#fff',
      padding: '20px 24px',
      marginBottom: '16px'
    }}
  >
    <Typography variant="h5" sx={{ marginBottom: '4px' }}>
      {title}
    </Typography>
    <Typography variant="caption" sx={{ display: 'block', marginBottom: '20px' }}>
      {description}
    </Typography>
    {children}
  </Box>
);

export default SettingsSection;
